import { ContainerModule } from "inversify";

export const PHARADAY_HARBOR_URL = "PHARADAY_HARBOR_URL";
export const PHARADAY_DOCUMENT_URL = "PHARADAY_DOCUMENT_URL";
export const EXECUTION_ENVIRONMENT = "EXECUTION_ENVIRONMENT";
export const MAPBOX_API_KEY = "MAPBOX_API_KEY";
export const MAPBOX_STYLES = "MAPBOX_STYLES";
export const NEXTAUTH_SECRET = "NEXTAUTH_SECRET";
export const POSTHOG_KEY = "POSTHOG_KEY";
export const POSTHOG_URL = "POSTHOG_URL";

export const EnvVariablesModule = new ContainerModule(bind => {
  bind(PHARADAY_HARBOR_URL).toConstantValue(process.env.NEXT_PUBLIC_PHARADAY_HARBOR_URL);
  bind(PHARADAY_DOCUMENT_URL).toConstantValue(process.env.NEXT_PUBLIC_PHARADAY_DOCUMENT_URL);
  bind(EXECUTION_ENVIRONMENT).toConstantValue(process.env.NEXT_PUBLIC_ENVIRONMENT ?? "development");
  bind(MAPBOX_API_KEY).toConstantValue(process.env.NEXT_PUBLIC_MAPBOX_API_KEY);
  bind(MAPBOX_STYLES).toConstantValue(process.env.NEXT_PUBLIC_MAPBOX_STYLES);
  bind(NEXTAUTH_SECRET).toConstantValue(process.env.NEXTAUTH_SECRET);
  bind(POSTHOG_KEY).toConstantValue(process.env.NEXT_PUBLIC_POSTHOG_KEY);
  bind(POSTHOG_URL).toConstantValue(process.env.NEXT_PUBLIC_POSTHOG_URL);
});
